import { IActivityEntity } from 'src/app/shared-layout/Components/activity/activity.interface';
import { UPDATE_BUILDING_ACTIVITIES, PREPEND_BUILDING_ACTIVITIES, CLEAR_BUILDING_ACTIVITIES } from './actionTypes';

const initialState = {
    id: '',
    events: [],
    totalRecords: 0,
  } as IActivityEntity;

export const buildingActivitiesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_BUILDING_ACTIVITIES:
      return {
        ...state,
        events: [
          ...(state.events || []),
          ...(action.buildingActivities?.events || []),
        ],
        totalRecords: action.buildingActivities?.totalRecords || state.totalRecords,
        cursor: action.buildingActivities?.cursor || state.cursor,
        id: action.buildingActivities?.id || state.id,
      };
    case CLEAR_BUILDING_ACTIVITIES:
        return initialState;
    case PREPEND_BUILDING_ACTIVITIES:
      return {
        ...state,
        events: [
          ...(state.events || []),
          ...action.payload.events,
        ],
      };
    default:
      return state;
  }
};